import ModuleInViewAnimationContainer from './moduleInViewAnimationContainer';
import { Flex, Text } from '@chakra-ui/react';


type MessageProps = {
	isSuccess: boolean;
	children: React.ReactNode | string;
	additionalMessage?: React.ReactNode | string;
}

const Message = ({ isSuccess, children, additionalMessage }: MessageProps) => {
	return (
		<ModuleInViewAnimationContainer>
			<Flex
				bg={isSuccess ? "green.100" : "red.100"}
				flexDir="column"
				w="100%"
				p="md"
				transition="all 0.2s ease-in-out"
				mb="lmd"
				borderRadius="3px"
				gap="xxs"
			>
				<Text color={isSuccess ? "green.800" : "red.800"}>
					{children}
				</Text>
				{additionalMessage && <Text color={isSuccess ? "green.800" : "red.800"}>{additionalMessage}</Text>}
			</Flex>
		</ModuleInViewAnimationContainer>
	)
};

export default Message; 